export default __webpack_public_path__ + "static/engine_banner-9e4fbb23a0235d6a207bee95285972b0.webp";